/**
 * Offline Banner Component
 *
 * Shown at the top of the chat when the device is offline.
 * Non-blocking - user can still see the chat but can't interact.
 */

import React from 'react';
import { AppColors, typography } from '../../theme/colors';
import { useLanguage } from '../../contexts/LanguageContext';

interface OfflineBannerProps {
  /** Whether to show the banner */
  isVisible: boolean;
}

export const OfflineBanner: React.FC<OfflineBannerProps> = ({ isVisible }) => {
  const { t } = useLanguage();

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: AppColors.warning,
        color: AppColors.textDark,
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        zIndex: 1500,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
      }}
    >
      {/* Offline Icon */}
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="1" y1="1" x2="23" y2="23" />
        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
        <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
        <line x1="12" y1="20" x2="12.01" y2="20" />
      </svg>
      <span
        style={{
          fontSize: typography.sm,
          fontWeight: 600,
        }}
      >
        {t('lifecycle.youreOffline')}
      </span>
    </div>
  );
};

export default OfflineBanner;
